<ion-header>
  <ion-toolbar color="primary">
    <ion-title class="header-title">Nuovo Paziente</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">Chiudi</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>


<div class="content-container">
  <div class="assistant-text-container">
    <p class="assistant-text">{{ payload?.message }}</p>
    <div class="details" *ngIf="payload?.assistantResponse?.content">
      <p>
        <strong>Codice fiscale:</strong>
        <input type="text" [(ngModel)]="fiscalCode" />
      </p>
      <p *ngIf="payload.assistantResponse.content.structureId"><strong>Struttura:</strong> {{
        payload.assistantResponse.content.structureId }}</p>
      <p *ngIf="payload.assistantResponse.content.context"><strong>Contesto:</strong> {{
        payload.assistantResponse.content.context }}</p>
      <p *ngIf="payload.assistantResponse.content.icd9"><strong>ICD9:</strong> {{ payload.assistantResponse.content.icd9
        }}</p>
    </div>
  </div>
</div>

<ion-footer *ngIf="hasMatchingPatients">
  <ion-toolbar> <ion-buttons slot="end">
      <ion-button color="medium" (click)="onCancel()">Annulla</ion-button>
      <ion-button color="primary" (click)="onConfirm()">
        Conferma
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>